// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/channel/components/Divider.module.css';
import {Trans} from '@lingui/react/macro';
import {clsx} from 'clsx';
import React from 'react';
export const Divider = React.forwardRef<
	HTMLDivElement,
	{
		red?: boolean;
		children?: React.ReactNode;
		spacing?: number;
		isDate?: boolean;
		style?: React.CSSProperties;
		className?: string;
		id?: string;
		onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
	}
>(({red = false, children, spacing = 8, isDate = false, style, className, ...rest}, ref) => {
	if (red) {
		if (isDate && children) {
			return (
				<div
					ref={ref}
					className={clsx(styles.unreadContainer, styles.unreadDate, className)}
					style={{marginTop: `${spacing}px`, marginBottom: `${spacing}px`, ...style}}
					{...rest}
				>
					<div className={styles.unreadLine} />
					<span className={styles.dateWithUnreadText}>{children}</span>
					<div className={styles.unreadLine} />
					<span className={styles.unreadBadge}>
						<Trans>New</Trans>
					</span>
				</div>
			);
		}
		return (
			<div ref={ref} className={clsx(styles.unreadContainer, className)} style={{...style}} {...rest}>
				<div className={styles.unreadLine} />
				<span className={styles.unreadBadge}>{children || <Trans>New</Trans>}</span>
			</div>
		);
	}
	return (
		<div
			ref={ref}
			className={clsx(styles.container, className)}
			style={{marginTop: `${spacing}px`, marginBottom: `${spacing}px`, ...style}}
			{...rest}
		>
			<div className={styles.line} />
			{children && <span className={clsx(styles.text, 'text')}>{children}</span>}
			<div className={styles.line} />
		</div>
	);
});
Divider.displayName = 'Divider';
